import axios, { type AxiosInstance, type AxiosRequestConfig, type AxiosResponse } from "axios";
import type { IHttpClientService } from "./interfaces/IHttpClientService.ts";
import { setupRequestInterceptor } from "./interceptors/requestInterceptor.ts";
import { setupResponseInterceptor } from "./interceptors/responseInterceptor.ts";

export class HttpClientService implements IHttpClientService {
  readonly api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: "/health/api",
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
      },
    });

    setupRequestInterceptor(this.api);

    setupResponseInterceptor(this.api);
  }

  get<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> {
    return this.api.get<T, R, D>(url, config);
  }

  post<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> {
    return this.api.post<T, R, D>(url, data, config);
  }

  put<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> {
    return this.api.put<T, R, D>(url, data, config);
  }

  delete<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D>,
  ): Promise<R> {
    return this.api.delete<T, R, D>(url, config);
  }
}
